export enum PricingMessages {
    EDITED = "pricing.messages.successEdited",
    ADDED = "pricing.messages.successAdded",
    PRICE_ALREDY_EXISTS = "pricing.messages.priceExists"
}